module.exports = __webpack_public_path__ + "img/um.8754eddf.svg";